import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@material-ui/core';
import styles from './PendingButton.module.scss';

interface PendingButtonProps extends ButtonProps {
  isPending: boolean;
  children: React.ReactNode;
}

const PendingButton = ({ isPending, children, ...otherProps }: PendingButtonProps): JSX.Element => (
  <Button {...otherProps} disabled={isPending}>
    {isPending && (
      <span className={styles.spinner}>
        <CircularProgress size='20px' color='secondary' />
      </span>
    )}
    {children}
  </Button>
);

export default PendingButton;
